import { InjectionToken } from '@angular/core';
import { SearchConfig } from './global-search-overlay-config';

export const SEARCH_CONFIG = new InjectionToken<SearchConfig>('SEARCH_CONFIG');
